<template>
  <el-dialog
          title="云打印配置"
          :visible.sync="dialogVisible"
          append-to-body
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
                    prop="state"
                    label="状态"
      >
        <el-switch
                v-model="form.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="0"
                inactive-value="1"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
              prop="terminal_number"
              label="终端号"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.terminal_number"   :disabled="isDisabled"></el-input>
      </el-form-item>

      <el-form-item
              prop="terminal_key"
              label="密钥"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.terminal_key"  :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-form-item
              prop="remarks"
              label="备注"
      >
        <el-input v-model="form.remarks"></el-input>
      </el-form-item>



      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>

    import * as userService from "@/api/sys/user";    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    import { Message } from 'element-ui'
    export default {
        name: "editprintingForm",
        props: {
            agent: Object,
            accuseVisible:Boolean,
            store_id:Number,
            value: Boolean
        },
        data() {
            return {
                formEdit: true,
                accuseVisible2:true,
                loading: false,
                dialogVisible: false,
                isDisabled:false,
                form: {
                    state: "0",
                    voice_state: "1"
                }

            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
                console.log("--value---"+val);
            },
            accuseVisible (newValue, oldValue) {
                console.log("-----"+newValue);
                this.accuseVisible2 = newValue;
            },

            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dialogOpen() {
                this.$refs.form.resetFields();


                if (this.agent.id) {
                    // userService.getUser(this.user.id).then(data => {
                    let form = {};
                    form.state = this.agent.state;
                    form.terminal_number = this.agent.terminal_number;
                    form.terminal_key = this.agent.terminal_key;
                    form.remarks = this.agent.remarks;

                    this.form = form;
                    // });
                    this.formEdit = this.accuseVisible2;
                    this.isDisabled=true;
                } else {
                    this.formEdit = this.accuseVisible2;
                    let form = {};
                    form.state="0";
                    this.form = form;
                    this.isDisabled=false;
                }
            },
            saveUser() {
                this.$refs["form"].validate(valid => {
                    if (valid) {


                                        this.loading = true;
                                        agentService.saveAgentStorePrinting({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.id,store_id:this.store_id })
                                            .then(data => {
                                                if(data!=""){
                                                    Message({
                                                        message: data,
                                                        type: 'error'
                                                    })
                                                }else{

                                                    Message({
                                                        message: '保存成功',
                                                        type: 'success'
                                                    })
                                                }
                                                this.loading = false;
                                                this.dialogVisible = false;
                                                this.$emit("submit");
                                            });


                    } else {
                        return false;
                    }
                });
            },
            close() {
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>

